import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import Link from 'components/shared/link';

import cn from 'classnames';
import styles from './styles.module.scss';
import useVideo from '../../../hooks/use-video';
import VolumeControl from '../../../icons/volume-control.inline.svg';
import { useMedia } from 'react-use';

const HeroWithMedia = ({
  title,
  description,
  bulletPoints = null,
  buttonLabel = null,
  buttonUrl = null,
  linkLabel = null,
  linkUrl = null,
  image = null,
  video = null,
  mediaPosition = 'right',
  mediaWidth = 60,
}) => {
  const { videoWrapperRef, videoRef, isUnmuteVisible, isVideoMuted, unmute, handleVideoEnd } =
    useVideo();

  const [isClient, setIsClient] = useState(false);
  const isMobile = useMedia('(max-width: 1198px)', false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <section className={styles.root}>
      <div className="container">
        <div className={styles.inner}>
          {isClient && isMobile && title && (
            <Heading className={styles.title} size="xl">
              {title}
            </Heading>
          )}
          <div className={cn(styles.content, styles[mediaPosition])}>
            {title && (!isClient || !isMobile) && (
              <Heading className={styles.title} size="xl">
                {title}
              </Heading>
            )}
            {description && <p className={styles.desc}>{description}</p>}

            {bulletPoints && (
              <ul className={styles.bullets}>
                {bulletPoints?.map((bullet, index) => (
                  <li className={styles.bullet} key={index}>
                    {bullet.text}
                  </li>
                ))}
              </ul>
            )}

            {buttonLabel && buttonUrl && (
              <div className={styles.actions}>
                <Link to={buttonUrl}>
                  <Button type="submit" theme="accent-primary">
                    {buttonLabel}
                  </Button>
                </Link>
              </div>
            )}

            {linkLabel && linkUrl && (
              <div className={styles.actions}>
                <Link to={linkUrl}>{linkLabel}</Link>
              </div>
            )}
          </div>
          <div
            className={cn(styles.media, styles[mediaPosition])}
            style={{ minWidth: `${mediaWidth}%` }}
          >
            {image && <img src={image} alt="" />}
            {video && !image && (
              <div className={styles.videoWrapper} ref={videoWrapperRef}>
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video
                  muted={isVideoMuted}
                  controls={!isVideoMuted}
                  playsInline
                  onEnded={handleVideoEnd}
                  ref={videoRef}
                >
                  <source src={video} type="video/mp4" />
                </video>
                {isUnmuteVisible && (
                  <Button
                    className={styles.buttonMute}
                    theme="primary"
                    size="sm"
                    data-type="video-mute-button"
                    onClick={unmute}
                  >
                    <VolumeControl />
                    &nbsp; Enable Audio
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

HeroWithMedia.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  buttonUrl: PropTypes.string,
  bulletPoints: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string })),
  linkLabel: PropTypes.string,
  linkUrl: PropTypes.string,
  image: PropTypes.string,
  video: PropTypes.string,
  mediaPosition: PropTypes.oneOf(['left', 'right']),
  mediaWidth: PropTypes.number,
};

export default HeroWithMedia;
